export default __webpack_public_path__ + "static/media/drinkscoffeetea_hero.789fe5c7.jpg";